import React from "react";
import { useTranslation } from "react-i18next";
import LoginDialog from "./title/loginDialog";

const TitleBar: React.FC = () => {
    const { t } = useTranslation("common");
    
    return (
        <header className="w-full border-b bg-white">
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">

                <div className="flex items-center gap-8">
                    <a href="/" className="text-lg font-bold text-black override">
                        {t('company')}
                    </a>

                    <nav className="flex items-center gap-6 text-sm font-medium text-black override">
                        <a href="/#customers" className="hover:text-gray-600 transition-colors">
                            {t('navigation.services')}
                        </a>
                        <a href="/#testimonies" className="hover:text-gray-600 transition-colors">
                            {t('navigation.testimonies')}
                        </a>
                        <a href="#careers" className="hover:text-gray-600 transition-colors">
                            {t('navigation.jobs')}
                        </a>
                    </nav>
                </div>
                <LoginDialog />
            </div>
        </header>
    );
};

export default TitleBar;